(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/rules/assets/javascripts/rules/joker.js') >= 0) return;  svs.modules.push('/components/numbergames/rules/assets/javascripts/rules/joker.js'); 
'use strict';

const joker = {
  getHuxfluxedRow() {
    const numbers = [];
    for (let i = 0; i < 7; i++) {
      numbers.push({
        number: Math.floor(Math.random() * 10),
        manual: false
      });
    }
    return numbers;
  },
  isValidRow(row) {
    if (Array.isArray(row)) {
      row = row.join('');
    }
    return /^[0-9]{7}$/.test(row);
  },
  getRowPrice() {
    return 10;
  },
  getJokerPrices() {
    return [0, 10, 20, 30];
  },
  getTopWin() {
    let jokerPrice = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
    const joker = {
      0: 0,
      10: 10000000,
      20: 20000000,
      30: 30000000
    };
    return joker[jokerPrice];
  },
  winConditions: [{
    numbers: 2
  }]
};
if (svs.isServer) {
  module.exports = {
    joker
  };
} else {
  svs.numbergames.rules.joker = joker;
}
 })(window);